import { Inmate } from '@reliance/types/models/Inmate';
import React from 'react';
import Table from '../mobile-device/usage/Table';

type UsageProps = {
  inmate: Inmate;
  tabSelected?: boolean;
  refreshTrigger?: number;
};

const Usage: React.FC<UsageProps> = (props) => {
  return (
    <div className="jarviswidget">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <Table
              inmate={props.inmate}
              tabSelected={props.tabSelected}
              refreshTrigger={props.refreshTrigger}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usage;
